// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_ByEntityInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /invoice/invoice/by_entity
 *
 * Retrieves the invoice linked to a related entity by type and ID.
 */
import { registerContract } from './validate'

export interface Invoice_ByEntityInput {
type: string
id: number
}

registerContract('Invoice_ByEntityInput', {
  type: { type: 'string',  required: true },
  id:   { type: 'number',  required: true },
})
